// src/pages/Reports/IssuanceReporting/PeriodSummaryClosing/PeriodSummaryTab.tsx
// RPT-017 (README.md mục 7) — tổng hợp TOÀN BỘ 1 kỳ xổ, tính REALTIME. Không phải bảng — hiển thị
// dạng thẻ số liệu (statistic cards), không phân trang/export (trả về 1 object).

import React, { useEffect, useState } from 'react';
import { Card, CardBody, Col, Row, Spinner } from 'reactstrap';
import { toast } from 'react-toastify';

import { getIssuancePeriodSummaryReportApi } from 'helpers/fakebackend_helper';
import IssuancePlanSelect from '../shared/IssuancePlanSelect';
import { formatCurrency, formatDate, formatPercent, formatQty } from '../shared/formatters';
import { IssuancePeriodSummaryReport } from '../shared/types';
import { createScreenText } from 'helpers/screenText';
const st = createScreenText('reports_issuance_reporting');

interface PeriodSummaryTabProps {
  planId: string;
  onPlanIdChange: (value: string) => void;
}

const StatCard: React.FC<{ label: string; value: string; colorClass?: string }> = ({ label, value, colorClass }) => (
  <Col md={3} sm={6}>
    <Card className="mb-3">
      <CardBody>
        <p className="text-muted mb-1">{label}</p>
        <h4 className={`mb-0 ${colorClass || ''}`}>{value}</h4>
      </CardBody>
    </Card>
  </Col>
);

const PeriodSummaryTab: React.FC<PeriodSummaryTabProps> = ({ planId, onPlanIdChange }) => {
  const [loading, setLoading] = useState(false);
  const [summary, setSummary] = useState<IssuancePeriodSummaryReport | null>(null);

  useEffect(() => {
    if (!planId) {
      setSummary(null);
      return;
    }
    setLoading(true);
    getIssuancePeriodSummaryReportApi(Number(planId))
      .then((res) => setSummary((res as any)?.data ?? res))
      .catch((error: any) => toast.error(error?.message || st('khong_the_tai_tong_hop_ky_message')))
      .finally(() => setLoading(false));
  }, [planId]);

  return (
    <>
      <Row className="g-3 mb-4">
        <Col md={4}>
          <label className="form-label">{st('ky_phat_hanh_label')}</label>
          <IssuancePlanSelect requireSelection value={planId} onChange={onPlanIdChange} />
        </Col>
      </Row>

      {!planId ? (
        <div className="text-center text-muted py-5">{st('vui_long_chon_ky_phat_hanh_text_2')}</div>
      ) : loading ? (
        <div className="text-center py-5"><Spinner color="primary" /></div>
      ) : summary ? (
        <>
          <div className="mb-3">
            <strong>{summary.planCode}</strong> {st('ngay_du_kien_xo_text_2')} {formatDate(summary.expectedDrawDate)}
            {' '}<span className="badge bg-info-subtle text-info ms-2">{summary.statusName}</span>
          </div>
          <Row>
            <StatCard label={st('tong_phat_hanh_label')} value={formatQty(summary.totalIssuedQuantity)} />
            <StatCard label={st('da_nhap_kho_column')} value={formatQty(summary.totalWarehousedQuantity)} />
            <StatCard label={st('da_giao_column')} value={formatQty(summary.totalDeliveredQuantity)} />
            <StatCard label={st('con_ton_column')} value={formatQty(summary.totalRemainingQuantity)} />
            <StatCard label={st('da_ban_column')} value={formatQty(summary.totalSoldQuantity)} colorClass="text-success" />
            <StatCard label={st('thu_hoi_column')} value={formatQty(summary.totalRecalledQuantity)} />
            <StatCard label={st('huy_column')} value={formatQty(summary.totalCancelledQuantity)} />
            <StatCard label={st('chenh_lech_column')} value={formatQty(summary.totalDiscrepancyQuantity)} colorClass="text-danger" />
            <StatCard label={st('gia_tri_phat_hanh_label')} value={formatCurrency(summary.totalIssuedValue)} />
            <StatCard label={st('gia_tri_da_ban_label')} value={formatCurrency(summary.totalSoldValue)} colorClass="text-success" />
            <StatCard label={st('gia_tri_thu_hoi_label')} value={formatCurrency(summary.totalRecalledValue)} />
            <StatCard label={st('ty_le_tieu_thu_column')} value={formatPercent(summary.consumptionRate)} />
          </Row>
        </>
      ) : null}
    </>
  );
};

export default PeriodSummaryTab;
